/**
 * Domain configuration for production custom domain
 * Handles canonical redirects and domain-specific settings
 */

export const CANONICAL_HOST = "www.somanistudio.in";
export const OLD_HOSTS = ["somanistudio.in"]; // Non-www version
export const DEV_HOSTS = ["localhost", "127.0.0.1"];

/**
 * Check if we're running in a development/preview environment
 */
export function isDev(): boolean {
  const host = window.location.hostname;
  return DEV_HOSTS.some((devHost) => host.includes(devHost)) || 
         host.includes("vercel.app"); // Vercel preview deployments
}

/**
 * Check if we're on the canonical production domain
 */
export function isCanonicalDomain(): boolean {
  return window.location.hostname === CANONICAL_HOST;
}

/**
 * Check if we need to redirect to the canonical domain
 */
export function shouldRedirectToCanonical(): boolean {
  if (isDev()) return false;
  
  const host = window.location.hostname;
  
  // Redirect non-www to www
  if (host === "somanistudio.in") return true;
  
  return false;
}

/**
 * Perform 308 permanent redirect to canonical domain
 * Preserves full path and query string
 */
export function redirectToCanonical(): void {
  const { pathname, search, hash } = window.location;
  const canonicalUrl = `https://${CANONICAL_HOST}${pathname}${search}${hash}`;
  
  // Use location.replace for permanent redirect behavior
  window.location.replace(canonicalUrl);
}

/**
 * Get the public site URL for auth redirects
 */
export function getPublicSiteUrl(): string {
  if (isDev()) {
    return window.location.origin;
  }
  return `https://${CANONICAL_HOST}`;
}

/**
 * Get the proper redirect URL for auth callbacks
 */
export function getAuthRedirectUrl(path: string = "/"): string {
  const baseUrl = getPublicSiteUrl();
  return `${baseUrl}${path}`;
}

/**
 * Get the invite link for a family token
 * Always uses the canonical production domain for invite links to ensure
 * mobile deep links work correctly regardless of which domain the admin is browsing from
 */
export function getInviteLink(token: string): string {
  const baseUrl = isDev() ? window.location.origin : `https://${CANONICAL_HOST}`;
  return `${baseUrl}/home?t=${token}`;
}
